import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from "@fortawesome/pro-solid-svg-icons/faAngleDoubleRight";
import { ButtonProps } from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

const ButtonExpandToView: React.FC<ButtonProps> = (props) => {
    const { t } = useTranslation();
    return (
        <button {...props} >
            <span><FontAwesomeIcon fixedWidth icon={faAngleDoubleRight} />{t("Common.Buttons.ExpandToViewText")}</span>
        </button>
    );
}

export default ButtonExpandToView;